/* Dondersteen: show ONLY media assigned to selected variant (Shopify variant_ids); keep unassigned media visible */
(function () {
  // Inject CSS so .ds-variant-hidden actually hides slides and thumbs
  if (!document.getElementById('ds-variant-media-style')) {
    const s = document.createElement('style');
    s.id = 'ds-variant-media-style';
    s.textContent = '.ds-variant-hidden{display:none!important;}.product__thumb.ds-variant-hidden{display:none!important;}';
    document.head.appendChild(s);
  }

  function getMainProductFormId(root) {
    const mainForm =
      root.querySelector('form.product-form[data-product-form]') ||
      root.querySelector('form[data-product-form]') ||
      root.querySelector('form.product-form');
    // Use getAttribute('id'): form.id returns the [name="id"] input due to HTML form named-element gotcha
    return mainForm ? mainForm.getAttribute('id') : null;
  }

  function getMainVariantInput(root) {
    const formId = getMainProductFormId(root);
    if (formId) {
      // Broadcast pattern: input[name="id"] lives outside the form, linked via form="<id>"
      const linked = root.querySelector(
        'input[name="id"][form="' + formId + '"], select[name="id"][form="' + formId + '"]'
      );
      if (linked) return linked;
    }
    // Fallback: any [name="id"] not inside installment or upsell forms
    const candidates = Array.from(root.querySelectorAll('input[name="id"], select[name="id"]'));
    return candidates.find(el => {
      const parentForm = el.closest('form');
      if (!parentForm) return true;
      return !parentForm.classList.contains('installment') && !parentForm.classList.contains('product-upsell__form');
    }) || candidates[0] || null;
  }

  function getSelectedVariantId(root) {
    const input = getMainVariantInput(root);
    return input && input.value ? String(input.value).trim() : null;
  }

  function parseVariantOrder(el, variantId) {
    const raw = (el.getAttribute('data-variant-order') || '').trim();
    if (!raw) return 9999;
    const pairs = raw.split(',').map(p => p.trim()).filter(Boolean);
    for (const p of pairs) {
      const parts = p.split(':');
      if (parts[0] === String(variantId)) {
        const n = parseInt(parts[1], 10);
        return isNaN(n) ? 9999 : n;
      }
    }
    return 9999;
  }

  function reorderByVariantOrder(root, selector, variantId) {
    const items = Array.from(root.querySelectorAll(selector + '[data-variant-order]'));
    if (!items.length) return;
    const groups = new Map();
    items.forEach(el => {
      const parent = el.parentNode;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach((group, parent) => {
      group.sort((a, b) => parseVariantOrder(a, variantId) - parseVariantOrder(b, variantId));
      group.forEach(el => parent.appendChild(el));
    });
  }

  function getFlickity(root) {
    if (!window.Flickity) return null;
    const slider =
      root.querySelector('[data-product-slideshow].flickity-enabled') ||
      root.querySelector('.product__slides.flickity-enabled') ||
      root.querySelector('.flickity-enabled');
    if (!slider) return null;
    return window.Flickity.data(slider) || null;
  }

  function applyFilter() {
    const root = document;
    const variantId = getSelectedVariantId(root);
    if (!variantId) return;

    // Target slides AND thumbnails that have variant binding
    const slides = Array.from(
      root.querySelectorAll('.product__slide[data-variant-ids], .product__thumb[data-variant-ids], [data-variant-ids][data-media-id]')
    );

    if (!slides.length) return;

    let visible = [];

    slides.forEach((slide) => {
      const idsRaw = (slide.getAttribute('data-variant-ids') || '').trim();

      // If no ids are present, treat as universal media
      if (!idsRaw) {
        slide.classList.remove('ds-variant-hidden');
        slide.classList.remove('media--hidden');
        visible.push(slide);
        return;
      }

      const ids = idsRaw.split(',').map(v => v.trim()).filter(Boolean);
      const shouldShow = ids.includes(String(variantId));

      // Use our own class (safer) and also honor Broadcast's hidden class if you’re already using it
      slide.classList.toggle('ds-variant-hidden', !shouldShow);
      slide.classList.toggle('media--hidden', !shouldShow);

      if (shouldShow) visible.push(slide);
    });

    // Safety: never allow the gallery to go empty
    if (!visible.length) {
      slides.forEach((s) => {
        s.classList.remove('ds-variant-hidden');
        s.classList.remove('media--hidden');
      });
      visible = slides;
    }

    // If active slide got hidden, move active to first visible
    const active = root.querySelector('.product__slide.media--active');
    const firstVisible = visible[0];
    if (active && (active.classList.contains('ds-variant-hidden') || active.classList.contains('media--hidden')) && firstVisible) {
      active.classList.remove('media--active');
      firstVisible.classList.add('media--active');
    }

    // Reorder visible slides/thumbs based on their position in the current variant's metafield entry
    reorderByVariantOrder(root, '.product__slide', variantId);
    reorderByVariantOrder(root, '.product__thumb', variantId);

    // Directly set active/hidden classes on slides (skips Broadcast's animation state bug)
    const firstVisibleSlide = root.querySelector('.product__slide:not(.ds-variant-hidden)');
    if (firstVisibleSlide) {
      root.querySelectorAll('.product__slide').forEach(slide => {
        if (slide === firstVisibleSlide) {
          slide.classList.add('media--active');
          slide.classList.remove('media--hidden', 'media--hiding');
        } else {
          slide.classList.remove('media--active', 'media--hiding');
          slide.classList.add('media--hidden');
        }
      });
      // Tell product-images to update its height for the new active slide
      const productImages = firstVisibleSlide.closest('product-images');
      if (productImages && typeof productImages.setHeight === 'function') {
        productImages.setHeight();
      }
    }
    // Set active thumb to match
    const firstVisibleThumb = root.querySelector('.product__thumb:not(.ds-variant-hidden)');
    if (firstVisibleThumb) {
      root.querySelectorAll('.product__thumb').forEach(t => t.classList.remove('is-active'));
      firstVisibleThumb.classList.add('is-active');
    }

    // Refresh slider
    const flkty = getFlickity(root);
    if (flkty) {
      flkty.reloadCells();
      flkty.resize();

      const firstVisibleSlide = root.querySelector('.product__slide[data-slide]:not(.ds-variant-hidden):not(.media--hidden)');
      if (firstVisibleSlide) {
        const idx = flkty.cells.findIndex((cell) => cell.element === firstVisibleSlide);
        if (idx >= 0) flkty.select(idx, false, true);
      }
    }

    window.dispatchEvent(new Event('resize'));
  }

  function patchProductImagesNavigation() {
    const productImages = document.querySelector('product-images');
    if (!productImages || productImages.__dsPatched) return;
    productImages.__dsPatched = true;

    productImages.getNextMediaId = function () {
      const current = this.querySelector('.product__slide.media--active');
      if (!current) {
        const firstVisible = this.querySelector('.product__slide:not(.ds-variant-hidden)');
        return firstVisible && firstVisible.getAttribute('data-media-id');
      }
      let next = current.nextElementSibling;
      while (next && (next.classList.contains('ds-variant-hidden') || !next.hasAttribute('data-image-id'))) {
        next = next.nextElementSibling;
      }
      if (!next) {
        next = this.querySelector('.product__slide:not(.ds-variant-hidden)');
      }
      return next && next.getAttribute('data-media-id');
    };

    productImages.getPreviousMediaId = function () {
      const current = this.querySelector('.product__slide.media--active');
      if (!current) {
        const firstVisible = this.querySelector('.product__slide:not(.ds-variant-hidden)');
        return firstVisible && firstVisible.getAttribute('data-media-id');
      }
      let prev = current.previousElementSibling;
      while (prev && (prev.classList.contains('ds-variant-hidden') || !prev.hasAttribute('data-image-id'))) {
        prev = prev.previousElementSibling;
      }
      if (!prev) {
        const visible = this.querySelectorAll('.product__slide:not(.ds-variant-hidden)');
        prev = visible[visible.length - 1];
      }
      return prev && prev.getAttribute('data-media-id');
    };
  }

  function init() {
    patchProductImagesNavigation();
    applyFilter();

    // Broadcast theme fires this when a variant is selected
    document.addEventListener('theme:variant:change', function () {
      setTimeout(function () { patchProductImagesNavigation(); applyFilter(); }, 10);
    });

    // Generic variant-change event name
    document.addEventListener('variant:change', function () {
      setTimeout(applyFilter, 10);
    });

    // Generic fallback: any change in variant pickers
    document.addEventListener('change', function (e) {
      const t = e && e.target;
      if (!t) return;
      if (
        t.matches('[data-single-option-selector]') ||
        t.closest('[data-product-variants]') ||
        t.closest('variant-selects') ||
        t.closest('radio-swatch') ||
        t.closest('.product__variants')
      ) {
        setTimeout(applyFilter, 10);
      }
    });

    // Ultimate fallback: watch the main variant input for value changes
    const idInput = getMainVariantInput(document);
    if (idInput && window.MutationObserver) {
      new MutationObserver(function () {
        setTimeout(applyFilter, 10);
      }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      // Some themes set value via JS property without firing change; observe change too
      idInput.addEventListener('change', function () {
        setTimeout(applyFilter, 10);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
